import React from 'react';

const Home = ({ onLogoClick }) => {
  const handleLogoClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    onLogoClick({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    });
  };

  return (
    <section className="home-section">
      <div className="home-container">
        <div className="logo-section" onClick={handleLogoClick}>
          <h2 className="sia-title">SIA</h2>
          <p className="sia-subtitle">Sistema Integrado Acadêmico</p>
        </div>
        
        <div className="hero-section">
          <h3 className="hero-title">Feito por professores, para professores</h3>
          <p className="hero-subtitle">
            Tecnologia inteligente que transforma a gestão educacional com funcionalidades 
            práticas e intuitivas para o dia a dia escolar.
          </p>
          
          <div className="features-grid">
            <div className="feature-card">
              <span className="feature-icon">📊</span>
              <h4>Gestão de Notas</h4>
              <p>Sistema completo para acompanhamento do desempenho dos alunos</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">📅</span>
              <h4>Calendário Escolar</h4>
              <p>Organize eventos, provas e atividades de forma integrada</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">🤖</span>
              <h4>Relatórios por IA</h4>
              <p>Análises inteligentes para melhorar o ensino e aprendizagem</p>
            </div>
            
            <div className="feature-card">
              <span className="feature-icon">�</span>
              <h4>Gestão de Turmas</h4>
              <p>Controle completo de turmas e matrículas</p>
            </div>
          </div>
        </div>
        
        <div className="cta-section">
          <div className="cta-content">
            <h4>Pronto para transformar sua gestão escolar?</h4>
            <p>
              Entre com sua conta para acessar todas as funcionalidades ou 
              cadastre-se para começar a usar o SIA.
            </p>
            <div className="cta-buttons">
              <button className="cta-primary" onClick={() => document.querySelector('.signin-button')?.click()}>
                Começar Agora
              </button>
              <button className="cta-secondary">
                Saiba Mais
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
